import * as jquery from 'jquery';

export default Object.assign(global, {
	$: jquery,
	jQuery: jquery,
});
